import React from 'react';
import PropTypes from 'prop-types';
export default function H4({ props, children }) {
    return <h4 {...props}>{children}</h4>;
}

H4.propTypes = {
    children: PropTypes.element,
};
